export const checkItemMap = {
  lg: {
    checkItemSize: 24,
    labelTextSize: 'xl',
    textMargin: 12,
  },
  md: {
    checkItemSize: 24,
    labelTextSize: 'lg',
    textMargin: 12,
  },
  sm: {
    checkItemSize: 24,
    labelTextSize: 'lg',
    textMargin: 12,
  },
  xs: {
    checkItemSize: 16,
    labelTextSize: 'md',
    textMargin: 8,
  },
} as const
